<template>
  <div class="wrap">
    <div class="container">
      <el-tabs
        v-model="activeId"
        class="tabs"
        type="border-card"
        style="margin-top: 30px"
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.id"
          :label="item.label || item.topLabel + item.bottomLabel"
          :name="item.id"
        >
          <div class="main">
            <keep-alive include="chapters">
              <router-view
                :classInfo="classInfo"
                @updateInfo="getClassInfo"
              ></router-view>
            </keep-alive></div
        ></el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog title="提示" :visible.sync="showTeamTips" width="30%" center>
      <p style="text-align: center">班级内有学生尚未组建或加入团队</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showTeamTips = false"
          >我知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { classInfo, allJoinTeam } from "@/api/class";
export default {
  name: "classCourse",
  data() {
    return {
      classInfo: {},
      activeId: "1",
      tabList: [
        {
          id: "1",
          label: "章节",
          text: "chapterCount",
          path: "/classCourse/chapters",
          show: true,
        },
        {
          id: "2",
          label: "团队",
          text: "teamCount",
          path: "/classCourse/teams",
          childrenPath: ["/classCourse/teams/teamDetail"],
          show: true,
        },
        {
          id: "3",
          label: "成员",
          text: "studentCount",
          path: "/classCourse/students",
          show: true,
        },
        // {
        //   id: "4",
        //   topLabel: "英雄",
        //   bottomLabel: "榜",
        //   path: "/classCourse/rank",
        //   show: false,
        // },
        {
          id: "5",
          topLabel: "抖音/快手",
          bottomLabel: "",
          path: "/classCourse/platformaccount",
          show: false,
        },
        {
          id: "6",
          topLabel: "作品",
          bottomLabel: "圈",
          path: "/classCourse/works",
          show: true,
        },
        // {
        //   id: "7",
        //   topLabel: "题",
        //   bottomLabel: "库",
        //   path: "/classCourse/questionBank",
        //   childrenPath: ["/classCourse/questionBank/detail"],
        //   show: true,
        // },
        // {
        //   id: "8",
        //   topLabel: "考",
        //   bottomLabel: "试",
        //   path: "/classCourse/exam",
        //   childrenPath: [
        //     "/classCourse/exam/detail",
        //     "/classCourse/exam/autoSetExam",
        //     "/classCourse/exam/setExam",
        //     "/classCourse/exam/examBank",
        //     "/classCourse/exam/settings",
        //     "/classCourse/exam/review",
        //     "/classCourse/exam/review/detail",
        //   ],
        //   show: true,
        // },
        // {
        //   id: "10",
        //   topLabel: "项目",
        //   bottomLabel: "实战",
        //   path: "/classCourse/projectPractice",
        //   childrenPath: [
        //     "/classCourse/projectPractice/buildTeam",
        //     "/classCourse/projectPractice/accountLocation",
        //     "/classCourse/projectPractice/accountEstablish",
        //     "/classCourse/projectPractice/copywriting",
        //     "/classCourse/projectPractice/scenario",
        //     "/classCourse/projectPractice/videoShooting",
        //     "/classCourse/projectPractice/videoClip",
        //     "/classCourse/projectPractice/accountOperation",
        //     "/classCourse/projectPractice/roadshow",
        //     "/classCourse/projectPractice/analysis",
        //   ],
        //   show: false,
        // },
        {
          id: "9",
          topLabel: "数据统计",
          bottomLabel: "",
          path: "/classCourse/evaluation",
          childrenPath: [
            "/classCourse/evaluation/knowledge",
            "/classCourse/evaluation/knowledge/situation",
            "/classCourse/evaluation/attitude",
            "classCourse/evaluation/attitude/detail",
            "classCourse/evaluation/skill",
            "classCourse/evaluation/skill/detail",
            "classCourse/evaluation/attainment",
            "classCourse/evaluation/attainment/detail",
            "/classCourse/evaluation/finalExam",
            "/classCourse/evaluation/teacherEvaluation",
          ],
          show: true,
        },
      ],
      showTeamTips: false,
    };
  },
  created() {
    if (!this.$route.query.id) this.$router.replace("/");
    this.getClassInfo();
    this.setActiveId();
    // this.checkTeam();
    this.$store.dispatch("getStudents", { classId: this.$route.query.id });
  },
  computed: {
    update() {
      return this.$store.state.update;
    },
  },
  watch: {
    $route() {
      this.setActiveId();
    },
    update(val) {
      if (val) {
        this.getClassInfo();
        this.$store.commit("SET_UPDATE", false);
      }
    },
    activeId(id) {
      let tab = this.tabList.find((item) => item.id == id);

      this.$router.push({
        path: tab.path,
        query: {
          id: this.$route.query.id,
          courseId: this.$route.query.courseId,
        },
      });
    },
  },
  methods: {
    // 班级信息
    getClassInfo() {
      // this.$loading.show();
      classInfo(this.$route.query.id).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          // console.log(res);
          this.classInfo = res.data;
          // this.tabList.find((item) => {
          //   return item.id == 6;
          // }).show = res.data.sz;
          this.tabList.find((item) => {
            return item.id == 5;
          }).show = res.data.douyin;
          this.tabList.find((item) => {
            return item.id == 4;
          }).show = !res.data.videoSz;
          this.tabList.find((item) => {
            return item.id == 10;
          }).show = res.data.videoSz;
        } else {
          console.log(res.msg);
        }
      });
    },
    setActiveId() {
      let activeTab = this.tabList.find((item) => {
        return item.path == this.$route.path;
      });
      if (!activeTab) {
        this.tabList.forEach((item) => {
          if (item.childrenPath) {
            if (this.$route.path.indexOf(item.path) != -1) activeTab = item;
          }
        });
      }
      this.activeId = activeTab.id;
    },
    checkTeam() {
      allJoinTeam(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.showTeamTips = !res.data;
        } else {
          console.log(res);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background-color: #f8f8f8;
  overflow: hidden;
  .container {
    overflow: initial;
  }
  .info_box {
    width: 100%;
    background: linear-gradient(180deg, teal, #4b45bd 100%);

    .cover {
      display: inline-block;
      width: 360px;
      height: 140px;
      vertical-align: top;

      .course_title,
      .course_class {
        margin-top: 20px;
        display: inline-block;
        margin-right: 20px;
        color: #fff;
        font-weight: bold;
        font-size: 24px;
        &.course_class {
          font-size: 20px;
        }
      }

      .desc {
        padding: 10px 20px;
        color: #fff;
        margin-top: 10px;
        max-height: 65px;
        font-size: 16px;
        text-indent: 2em;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
      }
    }

    .right {
      position: relative;
      display: inline-flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
      padding: 26px 40px;
      width: calc(100% - 360px);
      height: 140px;

      .weight_btn {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }

      .tabs {
        position: absolute;
        bottom: -14px;

        ::v-deep  .el-tabs__header {
          .el-tabs__nav-wrap::after {
            height: 4px;
            background-color: transparent;
          }
          .el-tabs__active-bar {
            height: 4px;
          }

          .el-tabs__item {
            color: #fff;
          }
        }
      }
    }
  }

  .back-row {
    margin-top: 10px;
    text-align: left;
  }
  .main {
    margin-top: 10px;
    margin-bottom: 30px;
  }
}
</style>